import React, { useEffect, useState } from "react";
import { loginUsingFB } from "../../utility/facebookProvider";
import { httpPost, httpGet } from "../../utility/requestHelper";
import { unifiedEnvConfig } from "../../constants/api-endpoint";
import { UserDropdown } from "../Shared/UserDropdown";
import { FacebookIcon, InstagramIcon } from "../Icons/icons.component";
import "./authorize.sass";
import Loader from "../Shared/Loader";
import { useSelector } from "react-redux";

export default function Authorize() {
  const [pages, setPages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const selectedClient =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.selectedClient
    ) || {};
  useEffect(() => {
    callPageApi();
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: process.env.REACT_APP_FB_APP_ID,
        cookie: true,
        xfbml: true,
        version: "v7.0",
      });
      window.FB.AppEvents.logPageView();
    };
    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  }, []);

  const authoriseAccount = () => {
    loginUsingFB()
      .then((token) => {
        if (token) {
          setIsLoading(true);
          setPages([]);
          httpPost(
            `${unifiedEnvConfig.SOCIAL_ACCOUNTS_AUTHORIZE}?client_id=${selectedClient.id}`,
            {
              token: token,
            }
          ).finally(() => {
            setIsLoading(false);
            callPageApi();
          });
        } else {
          // TODO: handle else part
        }
      })
      .catch((e) => console.log(e));
  };

  const callPageApi = () => {
    setIsLoading(true);
    httpGet(`${unifiedEnvConfig.SOCIAL_ACCOUNTS}`)
      .then((response) => {
        if (response && response.data && response.data.data) {
          setPages(response.data.data);
        }
      })
      .catch((e) => e)
      .finally(() => setIsLoading(false));
  };

  const renderPages = (pages) => {
    if (!pages) {
      return null;
    }
    return pages.map((pageGroup) => {
      if (!pageGroup) {
        return null;
      }
      let filteredPages = pageGroup.pages ? pageGroup.pages : [];
      filteredPages = filteredPages.filter((fp) => !fp.is_unauthorized);
      if (!filteredPages.length) {
        return null;
      }

      return (
        <div className="pageGroupWrap">
          <div className="pageGroupHeader">
            <span className="pgName">{pageGroup.name}</span>
            {pageGroup.email && (
              <span className="pgEmail">{pageGroup.email}</span>
            )}
          </div>
          <div className="pageGoupListing">
            {filteredPages.map((page) => {
              return (
                <div key={page.id} className="accountTile">
                  <div className="accDetails">
                    <div className="adLeft">
                      {
                        // eslint-disable-next-line
                        page.type == 1 ? <FacebookIcon /> : <InstagramIcon />
                      }
                      <span>{page.name}</span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      );
    });
  };

  return (
    <>
      {
        <div className="dashboardHeader">
          <div className="dashboardHeaderTop d-flex">
            <div className="dhLeft d-flex">
              <div className="dhLeftWrap">
                <h1>Authorize</h1>
              </div>
            </div>
            <div className="dhRight d-flex">
              <UserDropdown />
            </div>
          </div>
        </div>
      }

      <div className="mainContainer accContainer authorizeContainer">
        <div className="fbLoginBtnWrap">
          <button
            className="fbLoginBtn"
            value="Login"
            onClick={authoriseAccount}
          >
            <FacebookIcon />
            Authorize Facebook and / or Instagram Account(s)
          </button>
        </div>
        <div className="accountTitleListingWrap">
          {isLoading && <Loader />}
          {!!pages.length && (
            <div className="accountTitleListing">{renderPages(pages)}</div>
          )}
        </div>
      </div>
    </>
  );
}
